// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"26":"95325a9f","36":"bf68241c","213":"37ed3e22","395":"3d2409a7","423":"6f2470be","435":"59645992","457":"54408251","511":"5ec5bdfc","613":"10ffc642","695":"cbcfc2f4","711":"732c333e","722":"4f58f347","771":"3b9a9f7a","789":"1cdca34a","928":"62f20a85","985":"204f8ca4"}[chunkId] + ".chunk.js";
};